<template>
  <iframe :id="getIframeId" :src="url" class="w-100 iframe-component" style="border: none;" @load="onMessageLoad" />
</template>

<script>
export default {
  props: {
    url: String,
  },

  computed: {
    /**
     * @returns {number}
     */
    getIframeId() {
      return new Date().getUTCMilliseconds();
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    onMessageLoad() {
      let el = document.getElementById(this.getIframeId);
      if(el) {
        // here you can make the height, I delete it first, then I make it again
        el.height = "";
        el.height = el.contentWindow.document.body.scrollHeight + "px";
      }
    },
  },
}
</script>

<style scoped>

</style>
